import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createUserBusinessReportSlice = (set, get) => ({
    userSearch: {
        loading: false,
        data: [],
    },
    getUserBusiness: async ({ mobile }) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ userSearch: { ...state.userSearch, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/user-business-report/mobileNumber/${mobile}`,
                headers: { token },
            });
            set(state => ({ userSearch: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ userSearch: { ...state.userSearch, loading: false } }));
        }
    },
    GetUserBusinessSuccess: (data) => {
        set(state => ({ ...state, userSearch: { ...state.userSearch, data } }));
    }
});
